import { isBlank } from './is_blank'
import customLocalStorage from 'store'
/**
 * 获取拼接过的图片url
 * @param {string} img 图片路径
 * @param {string} source 来源， supplier：供应商端，默认食堂端
 * @return {string} 完整图片路径
 */
export const setProductImg = function (img, source) {
  let imgHost = ''
  if (source === 'supplier') {
    imgHost = 'http://3c-supplier-t.deyicy.com/'
  } else if (isBlank(source)) {
    imgHost = customLocalStorage.get('canteenPCHost')
  } else if (source === 'central') {
    imgHost = 'https://3c-central.deyicy.com/'
  } else {
    imgHost = source
  }
  if (isBlank(img)) {
    return require('../assets/images/defaultPImg.png')
  } else {
    return (imgHost + img.split(',')[0])
  }
}


// WEBPACK FOOTER //
// ./src/utils/setProductImg.js